import { render, staticRenderFns } from "./DocumentTab.vue?vue&type=template&id=e9da5776&"
import script from "./DocumentTab.vue?vue&type=script&lang=js&"
export * from "./DocumentTab.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9da5776')) {
      api.createRecord('e9da5776', component.options)
    } else {
      api.reload('e9da5776', component.options)
    }
    module.hot.accept("./DocumentTab.vue?vue&type=template&id=e9da5776&", function () {
      api.rerender('e9da5776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/DocumentTab.vue"
export default component.exports